export const en = {
    'exclude-phrases': 'Disable keywords without impressions'
};
